import React from 'react';
import Promise from 'bluebird';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_removeModal} from '../../../store';
import PropTypes from 'prop-types';
import Table from '../../Table';
import axiosInstance from '../../../utils/axios';
import {_openModal} from '../../../reducers/modals';
import debug from 'debug';
import {Button, LoadingSpinner} from '../../../../shared';

const log = debug('circleblack:apply-entitlements');

const ApplyEntitlements = props => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [entTermInput, setEntTermInput] = React.useState('');

  const gatherItems = inputValue => {
    const filters = {};
    if (props.content.cat === 'firms') {
      filters.skipDetails = true;
    }
    log('gathering items', props.content.search, inputValue, filters);
    return axiosInstance.get('/' + props.content.cat, {params: {...props.content.search, ...inputValue, ...filters}})
      .then(function entitlementSuccess(res) {
        log('Product return:', res.data);
        return res.data;
      })
      .catch(function error(err) {
        log('error', err);
        throw err;
      });
  };

  const dataManager = {};
  if (!~['userLookup', 'configuration'].indexOf(props.content.cat)) {
    dataManager.gatherData = gatherItems;
  }
  if (props.content.cat === 'userLookup') {
    dataManager.gatherData = () => Promise.resolve([props.content.user]);
  }
  dataManager.setSelectedRows = setSelectedRows;

  const modifyEntitlement = item => {
    const filters = {...props.content.selection};
    filters.access = filters.access === '*' ? ['c', 'r', 'u', 'd'] : filters.access;
    return axiosInstance.put(
      '/entitlements',
      {
        target: props.content.cat === 'userLookup' ? 'users' : props.content.cat,
        targetID: item.id,
        group: filters.group,
        feature: filters.feature,
        access: filters.access,
        action: filters.status,
        role: filters.role,
        level: filters.level,
      }
    )
      .then(() => {
        item.result = 'Success';
        return item;
      })
      .catch(err => {
        item.result = (err.response && err.response.data && err.response.data.error && err.response.data.error.msg)
          || `${err.response.status} ${err.response.statusText}`;
        return item;
      });
  };

  const updateEntitlements = () => {
    setLoading(true);
    return Promise.map(selectedRows, modifyEntitlement)
      .then(rows => {
        props.openModal({
          type: 'MessageModal',
          title: 'Entitlements Applied',
          body:
            <Table dataSet={rows}
                   columns={[
                     {
                       title: 'ID',
                       dataPoint: 'id',
                       type: 'text',
                       minWidth: 50,
                       isSortable: true,
                     },
                     {
                       title: 'Name',
                       dataPoint: 'name',
                       type: 'text',
                       minWidth: 50,
                       isSortable: true,
                     },
                     {
                       title: 'Result',
                       dataPoint: 'result',
                       type: 'text',
                       minWidth: 50,
                       isSortable: true,
                     },
                   ]}
                   defaultSort={{
                     column: 'id',
                     desc: false,
                   }}
                   height={'300px'}/>,
        });
        props.content.onSuccess();
        props.dispatchRemoveModal(props.content);
      })
      .catch(err => {
        setLoading(false);
        props.openModal({
          type: 'MessageModal',
          title: 'Apply Entitlements',
          body: (err.response && err.response.data && err.response.data.error && err.response.data.error.msg)
            || `${err.response.status} ${err.response.statusText}`,
        });
      });
  };

  const updateConfiguration = () => {
    log('updateConfiguration:::', this);
    return axiosInstance.post(
      '/entitlements/terms',
      {
        name: entTermInput,
        feature: props.content.selection.feature,
        group: props.content.selection.group,
        access: props.content.selection.access,
      }
    )
      .then(() => {
        props.openModal({
          type: 'MessageModal',
          title: 'Entitlement Configuration',
          body: 'Success',
        });
        props.content.onSuccess();
        props.dispatchRemoveModal(props.content);
      })
      .catch(err => {
        log('err', err);
        props.openModal({
          type: 'MessageModal',
          title: 'Entitlement Configuration',
          body: (err.response && err.response.data && err.response.data.error && err.response.data.error.msg)
            || `${err.response.status} ${err.response.statusText}`,
        });
      });
  };

  const submit = () => {
    if (props.content.cat === 'configuration') return updateConfiguration();
    return updateEntitlements();
  };

  log('rendering');
  const selection = props.content.selection;
  const {dispatchRemoveModal} = props;
  return <BaseModal onClose={() => dispatchRemoveModal(props.content)} title={'Apply Entitlements'}>
    {Object.keys(selection).map(s => <div key={s}>{s}: {selection[s]}</div>)}
    {loading && <LoadingSpinner/>}
    {(!~['userLookup', 'configuration'].indexOf(props.content.cat) && !loading)
    && <Table dataManager={dataManager}
              columns={[
                {
                  title: 'ID',
                  dataPoint: 'id',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
                {
                  title: 'Name',
                  dataPoint: 'name',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
                ...props.content.cat === 'users' ? [
                  {
                    title: 'Email',
                    dataPoint: 'email',
                    type: 'text',
                    minWidth: 50,
                    isSortable: true,
                  },
                ] : [],
              ]}
              defaultSort={{
                column: 'id',
                desc: false,
              }}
              select={{
                max: 100,
              }}
              rowIdentifier={'id'}
              height={'300px'}/>
    }
    {(props.content.cat === 'userLookup' && !loading)
    && <Table dataManager={dataManager}
              columns={[
                {
                  title: 'ID',
                  dataPoint: 'id',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
                {
                  title: 'Email',
                  dataPoint: 'email',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
                {
                  title: 'Role',
                  dataPoint: 'role',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
                {
                  title: 'level',
                  dataPoint: 'levelName',
                  type: 'text',
                  minWidth: 50,
                  isSortable: true,
                },
              ]}
              defaultSort={{
                column: 'id',
                desc: false,
              }}
              select={{
                max: 100,
              }}
              rowIdentifier={'id'}
              height={'300px'}/>
    }
    {(props.content.cat === 'configuration' && !loading)
    && <input type={'text'}
              value={entTermInput}
              onChange={evt => setEntTermInput(evt.target.value)}
              minLength={1}
              maxLength={250}/>}
    {!loading && <div>
      <Button
        importance={'secondary'}
        size={'lg'}
        label={'Cancel'}
        disabled={false}
        action={() => dispatchRemoveModal(props.content)}>
      </Button>
      <Button
        importance={'primary'}
        size={'lg'}
        label={'Submit'}
        disabled={!selectedRows.length && !entTermInput.length}
        action={submit}>
      </Button>
    </div>}
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(null, mapDispatchToProps)(ApplyEntitlements);

ApplyEntitlements.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    componentName: PropTypes.string.isRequired,
    cat: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    search: PropTypes.object,
    selection: PropTypes.shape({
      group: PropTypes.string,
      feature: PropTypes.string,
      access: PropTypes.string,
    }),
    user: PropTypes.object,
  }),
  openModal: PropTypes.func.isRequired,
  dispatchRemoveModal: PropTypes.func.isRequired,
};
